<template>
  <div>

    <!--title start-->
    <div id="printtitle">
      <!-- menu title -->
      <div class="grab">
        <div class="tit_nav">
          <h4>{{$t(pagetitle)}}</h4>

        </div>
      </div>
    </div>

    <!--content start-->
    <div id="board02_detail_wrap">
      <div class="grab">
        <div class="board02_detail">
          <div class="border_dashed_b">
            <p class="board02_title">{{title}}</p>
            <p class="board02_date">{{dateStr}}</p>
          </div>
          <div class="board02_detail_body">
            <div id="app">
              <span v-html="contents"></span>
            </div>
          </div>
        </div>
        <div class="board02_detail_button">

          <button v-on:click="goList()">{{ $t("list") }}</button>
          <!--<button v-on:click="update()">{{ $t("next") }}<span class="glyphicon glyphicon-chevron-right"></span></button>-->
        </div>
      </div>
    </div>

  </div>
</template>
<script>
  import api from '../api/api'
  import Constant from '../constant'
  import { mapState } from 'vuex'

  export default
  {
    name: 'NoticeDetail',
    data: function () {
      return {
        /*title: "한-중-일 동아시아 VLBI 네트워크 본격 관측운영을 위한 MOU 체결",
        date:"2018-09-09",
        contents: "<img src=\"http://mimgnews1.naver.net/image/109/2016/11/03/201611030735776051_581a6b4fe4d26_99_20161103075805.jpg?type=w540\" alt=\"이미지의 묘사 내용\" />\n <br>" +
        " ■ 한sss-중-일 3국이 동아시아 지역 전파망원경 21대를 연결해 수 천 km 크기를 가진 망원경을 구현하는 동아시아 VLBI 네트워크(이하 EAVN, East Asian VLBI Network)를 위해 본격적으로 손을 잡았다.\n" +
        "            ※ VLBI : 초장기선 전파간섭계(Very Long Baseline Interferometer)의 줄임말. 멀리 떨어진 여러 전파망원경을 동시 운용함으로써 그 거리에 상당하는 크기의 해상도를 얻는 관측 기술 또는 관측 장치.\n" +
        "            □ 한국천문연구원(KASI, 원장: 이형목)은 일본국립천문대(NAOJ, 대장: Saku Tsuneta), 중국상해천문대(SHAO, 대장: Zhi-Qiang Shen), 중국신장천문대(XAO, 대장: Na Wang)와 지난 9월 6일 평창 용평리조트에서 개최된 “제 11회 동아시아 VLBI 워크숍”에서 EAVN의 운영 및 과학기술 연구협력을 위한 업무협약을 체결했다.\n" +
        "            □ 2008년 EAVN 구성에 관한 첫 논의가 시작된 이래로 동아시아 연구자들은 지난 수년간 한국의 KVN, 일본의 VERA, 중국의 CVN 등 한중일 3개국 최대 21개 망원경들을 연결해 하나의 거대한 VLBI 관측망으로 만들기 위한 노력을 해왔다."
        title: "한-중-일 동아시아 VLBI 네트워크 본격 관측운영을 위한 MOU 체결",*/
        title:"",
        date:"",
        contents: ""
      }
    },
    props: {
      type : { default:-1}, //0;센터소식 , 1: 학술 및 홍보활동
      contentsNo: {default:-1}
    },
    computed: _.extend({
      test: function ()
      {
      },
      pagetitle: function () {
        console.log('page_title' + ' call ' + JSON.stringify(this.board_detail ))
        if (this.type == 0) return "centernews";
        else if (this.type == 1) return "centeractive";
      },
      dateStr: function()
      {
        return this.date.substring(0,10) + " " + this.date.substring(11,17)
      },
      init_update() {

      }
    },mapState(['user_name' , 'board_detail'])),

    mounted: function () {
      console.log('## xx '+  this.type + ' ' + this.contentsNo)
      console.log('## xx1 '+  this.user_name)
      console.log('## xx1 '+  this.board_detail.type)

      if(this.type == -1 && this.contentsNo== -1) {
        this.type = this.board_detail.type
        this.contentsNo = this.board_detail.contentsNo
      }
      else
      {
        //save localstorage
        this.$store.commit(Constant.BOARD_DETAIL , {type:this.type , contentsNo:this.contentsNo})
      }
      this.update()
    },
    methods : {
      goList: function() {
        //this.$router.push()
        //this.$router.push({name: "researchwrite" , params:{type:0,contentsNo:0} })
        if(this.type==0)
          this.$router.push({name: "noticenews" })
        else
          this.$router.push({name: "noticeactive" })
      },
      update : function() {
        if(this.contentsNo > 0) {
          console.log('## created contents no : ' + this.contentsNo)
          api.reqContents(this.contentsNo)
            .then((response) => {
              if (response.data.status === 'success') {
                this.title = response.data.title;
                this.contents = response.data.contents;
                this.date = response.data.date
              }
              else {
                console.log('## 3 ' + JSON.stringify(response.data));
                alert('에러 : ' + response.data.message)
              }
            })
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/NoticeDetail.vue